import { Target } from "lucide-react";

const taCls = "w-full mt-1 rounded-md bg-slate-800 border border-slate-600 px-2.5 py-2 text-sm text-slate-100 outline-none focus:border-[#818CF8] resize-y disabled:opacity-40";

function Block({ title, checked, onToggle, value, onChange, placeholder, hint, id }) {
  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        <label className="text-sm text-slate-200">{title}</label>
        <label className="text-xs text-slate-300 flex items-center gap-1.5 cursor-pointer">
          <input type="checkbox" data-testid={`lp-ai-${id}`} checked={checked} onChange={(e) => onToggle(e.target.checked)} className="accent-[#22D3EE]" /> Let AI generate {id}
        </label>
      </div>
      <textarea data-testid={`lp-${id}`} rows={3} disabled={checked} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={taCls} />
      <p className="text-[11px] text-muted-foreground mt-1">{checked ? hint : "Pasted text is copied into the box exactly as written."}</p>
    </div>
  );
}

export default function StandardsCard({ header, setHeader }) {
  const set = (patch) => setHeader((h) => ({ ...h, ...patch }));
  return (
    <div className="hq-glass rounded-2xl p-4 space-y-4" data-testid="lp-standards-card">
      <p className="text-sm font-medium text-slate-200 flex items-center gap-2"><Target className="w-4 h-4 text-[#818CF8]" /> Standards &amp; Objectives</p>
      <Block id="standards" title="Standards" checked={!!header.aiStandards} onToggle={(v) => set({ aiStandards: v })} value={header.standards || ""} onChange={(v) => set({ standards: v })}
        placeholder={"Paste your state/district standards here, e.g.\nISTE 1.1.c – Students use technology to seek feedback…"} hint="AI will write relevant ISTE / CTE standards for each day's work." />
      <Block id="objectives" title="Learning Objectives" checked={!!header.aiObjectives} onToggle={(v) => set({ aiObjectives: v })} value={header.objectives || ""} onChange={(v) => set({ objectives: v })}
        placeholder={"Enter specific learning objectives, e.g.\n- Students will be able to apply bold, italic and underline…"} hint="AI will write SWBAT-style objectives from each day's lessons." />
    </div>
  );
}
